
import { Action, Getter } from 'vuex-class'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getCompanyAddressInfo } from '@/api/buyCar'
import {
  updateOrderStatus,
  updateOrderPayStatus,
  modifyOrder,
  backOrder,
  modifyOrderAttachFile,
  purchaseOrderAgainAppApi
} from '@/api/order'
import AppendixName from '@/components/AppendixName/index.vue'
import StepTemp from '@/components/StepTemp/index.vue'
import LogPopup from '@/views/industryMall/order/LogPopup.vue'
import {
  GoodsListOfCategoryFormatDto,
  SelectGoodsOptionsDto
} from '@/api/commonConfig'
import {
  getStoreOrderDtl,
  getStoreOrderNodeList,
  storeGoodsAgain,
  getStoreOrderCanReturn,
  cusStockInStoreOrder,
  cancelStoreOrder
} from '@/api/industryMall'
import { getAvoidLoginUrl,getWhiteSign } from "@/api/iousServices";
import { ShopOrderInfoDto, OrderDelDTO } from './order'
import { getPickupConfig } from '@/api/industryMall'
import { backToBefore, openFDWhitePage, callPhone, getUserLocationInfo, goToNavigation } from '@/utils/h5ToApp'
import { toNumber } from 'lodash'
import { keepDecimal, calculateDistance } from '@/utils/util'
import Clipboard from 'clipboard'
import PayBtn from '@/views/iousServices/template/payBtn.vue'
import dayjs from "dayjs";
import math from '@/core/math'
import store from '@/store'
import { LoginReturnDataDto } from '@/utils/h5ToApp'
import goodsListPopup from './template/goodsListPopup.vue'
import SupplementaryPayBtn from '@/views/iousServices/template/supplementaryPayBtn.vue'

@Component({
  name: 'OrderMallDetail',
  components: {
    AppendixName,
    StepTemp,
    PayBtn,
    LogPopup,
    goodsListPopup,
    SupplementaryPayBtn
  },
  filters: {
    filterDisWay(val: number) {
      const ways = [
        { id: 1, value: '送货上门' },
        { id: 2, value: '客户自提' },
        { id: 3, value: '商家配送' },
        { id: 4, value: '骑手配送' },
        { id: 5, value: '其他' }
      ]
      let desc = ways.find((item) => item.id === val)
      return desc ? desc.value : '--'
    },
  }
})
export default class OrderMallDetail extends Vue {
  @Getter companyId!: string
  @Getter selectList!: SelectGoodsOptionsDto[]
  @Getter whiteStrips!: number
  @Getter mobile!: string
  @Action setSelectList!: (val: SelectGoodsOptionsDto[]) => void
  @Action setOrderFromPage!: (val: string) => void
  @Getter info!: LoginReturnDataDto

  showPopover = false

  // 订单信息对象
  orderInfo: ShopOrderInfoDto = {}

  orderId = ''
  currRouteId = ''
  // 是否初始化获取数据完成
  isInit = false
  // 是否修改订单信息对象
  isUpdateOrderInfo = false
  // 进度条数据
  stepList: any[] = []
  params: {
    orderId?: string
  } = {}
  isEdit = false
  isEditOrder = false // 是否是修改订单状态
  fromPage = '' // fromPage=='1'的时候，说明是原生跳转过来的，此时，返回按钮需要调用原生返回方法

  // 签约时间
  whiteSignTime = ''
  endSignTime = ''

  selectGoodsList: GoodsListOfCategoryFormatDto[] = []
  pickUpInfo: any = {}
  locationInfo = { longitude: 0, latitude: 1 } // 用户经纬度信息

  @Watch('orderInfo', { deep: true, immediate: true })
  onOrderInfoChange(newVal, oldVal) {
    console.log('this.orderInfo', this.orderInfo)
    if (this.isInit) {
      this.isUpdateOrderInfo = true
    }
  }

  @Watch('orderInfo.payFreight', { deep: true, immediate: true })
  payFreightChange(val: string) {
    // this.orderInfo.orderMoney = Number(
    //   math.mathAdd(this.orderInfo.orderTotalMoney, val)
    // )
  }

  /* 计算所有的价格 */
  get goodsPriceAmount() {
    let price = 0
    const del = this.orderInfo.del
    if (del && del.length) {
      price = del.reduce((prev, next: OrderDelDTO) => {
        return prev + Number(next.goodsPrice) * next.saleAmount
      }, 0)
    }
    return price
  }

  getGoodsMoney (store: any) {
    let goodsMoney = Number(math.mathSubtract(Number(store.orderMoney), Number(store.payFreight || '0')))
    goodsMoney = Number(math.mathSubtract(goodsMoney, Number(store.serviceMoney || '0')))
    return keepDecimal(goodsMoney, 2)
  }

  // 是否显示立即支付按钮
  isShowPay(orderInfo) {
    if(Number(orderInfo.payStatus) === 1 && Number(orderInfo.orderStatus) === -1) {
      return false
    }
    if(Number(orderInfo.payStatus) === 1 || Number(orderInfo.payStatus) === -1) {
      return true
    }
    if( Number(orderInfo.payStatus) === 3 && Number(orderInfo.alternateMoney)===0  && ((orderInfo.payWay === 2) || orderInfo.payWay ===3)) {
      return true
    }
  }

    // 是否显示 候补金额按钮
  isShowPay1(orderInfo) {
    if(Number(orderInfo.payStatus) === 3 && Number(orderInfo.alternateMoney)>0) {
      return true
    }
    if((Number(orderInfo.payStatus) === 2 || Number(orderInfo.payStatus) === 4) && Number(orderInfo.alternateMoney)>0) {
      return true
    }
  }

  // 是否显示取消按钮
  get showCancelBtn() {
    if(Number(this.orderInfo.orderStatus) === -1) {
      return false
    }
    if([10,30].includes(Number(this.orderInfo.orderStatus))) {
      return false
    }
    if([0,1].includes(Number(this.orderInfo.payWay)) && Number(this.orderInfo.payStatus) === 1) {
      return true
    }
    if([2,3].includes(Number(this.orderInfo.payWay))) {
      return [1,-1].includes(Number(this.orderInfo.payStatus))
    }
    return false
  }

  // 获取用户经纬度信息（从原生获取）
  getLocationInfo () {
    getUserLocationInfo().then((res: any) => {
      this.locationInfo.longitude = res.longitude
      this.locationInfo.latitude = res.latitude
    })
  }

  // 计算客户与店铺距离
  getDistance (store: any) {
    if (this.locationInfo.longitude < 1) return '--'
    return calculateDistance(this.locationInfo.longitude, this.locationInfo.latitude, store.pickupLongitude, store.pickupLatitude)
  }

  created() {
    let query = this.$route.query
    this.orderId = this.$route.query.orderId as string
    // this.currRouteId = this.$route.query.currRouteId as string
    this.params = {
      // companyId: this.companyId,
      orderId: query.orderId as string // 订单id
      // currRouteId: query.currRouteId as string // 分区序号
    }

    this.fromPage = query.fromPage ? (query.fromPage as string) : '0'

    if (this.fromPage === '1') this.setOrderFromPage('1')
    this.init()
    console.log('ordermalldetail',this.whiteStrips);
  }

  activated() {
    this.init()
    this.fromPage = this.$route.query.fromPage
      ? (this.$route.query.fromPage as string)
      : '0'
    if (this.fromPage === '1') this.setOrderFromPage('1')
  }

  init() {
    // 获取订单详情信息
    this.getInfo()
    this.getAddressInfo()
    this.getSign()
  }

  // 跳转至华润银行H5
  goSign() {
    if(this.orderInfo.nodeId !== '2' ) {
      return
    }
    this.signContract()
  }

  signContract() {
    // 是否签署授权书
    if (window.localStorage.getItem('isSign') == '1' && this.whiteSignTime < this.endSignTime) {
      this.fdfreeLogin('4')
    } else {
      window.localStorage.removeItem('isSign')
      this.$router.push({
          path: "/iousAuthorize",
          query: {
              webshow: '4'
          },
      });
    }
  }
  getSign() {
    // 获取授权书记录
    getWhiteSign().then((res =>{
      const { code, data } = res
      if( code === "000000" && data) {
        let firstSignTime = data.whiteSignTime
        firstSignTime = dayjs(firstSignTime).format("YYYY-MM-DD")
        this.endSignTime = dayjs(firstSignTime).add(360, 'day').format("YYYY-MM-DD");
        this.whiteSignTime = dayjs().format("YYYY-MM-DD");
        console.log('首次签署日期=======',firstSignTime);
        console.log('再次签署日期=======',this.endSignTime);
        if (this.whiteSignTime < this.endSignTime) window.localStorage.setItem('isSign','1')
      }
    }))
  }

  // 1还款入口 2授信入口 3借款入口 4全局弹框
  // 进入华润
  fdfreeLogin(flag = '') {
    let params = {
      companyId: this.companyId,
      webShow: flag
    }
    getAvoidLoginUrl({...params}).then((res) =>{
      const { code, data } = res
      if( code === "000000" ) {
        // 是否签约
        // setSessionItem('signContract', '1')
        let encodeUrl = encodeURI(data.responseData.redirectUrl)
        // 完成授信流程，webShow=1或3替换成2
        if (encodeUrl.indexOf('webShow=1') > -1 || encodeUrl.indexOf('webShow=2') > -1 || encodeUrl.indexOf('webShow=3') > -1 || encodeUrl.indexOf('webShow=4') > -1) {
          encodeUrl.replace(/webShow=[d{1,2,3,4}]/,`webShow=${flag}`)
        }
        let isQuery = encodeUrl.indexOf('?') > -1
        let url = `${encodeUrl}${isQuery? '&' : '?'}userPhone=${this.mobile}`
        openFDWhitePage({url})
        console.log('getAvoidLoginUrl=',url);
      }
    }).catch(() => {
      this.$toast('此产业商城暂未开通白条快付')
    })
  }

  /**
   * @description 关联退单
   *
   */
  goReturnList() {
    this.$router.push({
      path: '/orderMall',
      query: {
        orderName: '退货售后',
        orderId:this.orderInfo.orderId,
        form: 'orderMall'
      }
    })
    // this.$eventBus.$emit('refreshStatus', '退款申请')
  }

  /* 获取地址信息 */
  getAddressInfo() {
    getCompanyAddressInfo({ companyId: this.companyId }).then((res) => {
      if (res.data.addressList && res.data.addressList.length > 0) {
        const list = res.data.addressList.filter((item) => item.isDefault)
        if (list && list.length > 0) {
          // this.addressInfo = list[0]
          // this.submitData.receiveAddress = this.addressInfo.addressId
          // this.submitData.receiveAddressDtl = this.addressInfo.addressDtl
          // this.submitData.receiveMobile = this.addressInfo.receiveMobile
          // this.submitData.receiveMan = this.addressInfo.receiveMan
        } else {
          // this.addressInfo = {}
          // this.submitData.receiveAddress = ''
          // this.submitData.receiveAddressDtl = ''
          // this.submitData.receiveMobile = ''
          // this.submitData.receiveMan = ''
        }
      }
    })
  }

  /**
   * 再次购买
   */
  buyAgain() {
    // purchaseGoodsAgain(this.params)
    let data = {
      orderId: this.orderId,
      storeId: this.orderInfo.storeId
    }
    storeGoodsAgain(data)
      .then(() => {
        this.$toast.success('已添加至购物车')
        store.dispatch('getShopCarNum', this.info.partnerCompanyId)
      })
      .catch(() => {})
  }

  /**
   * 确认收货
   */
  confirmOrder() {
    cusStockInStoreOrder({
      storeId: this.orderInfo.storeId,
      orderId: this.orderInfo.orderId
    })
      .then((res) => {
        let msg = ''
        if (res.code === '000000') {
          msg = '确认收货成功'
        } else if (res.code === '000002') {
          msg = '订货单状态已变更'
        }
        this.$dialog
          .alert({
            message: msg
          })
          .then(() => {
            this.getInfo()
          })
      })
      .catch(() => {})
  }

  /* 取消订单 */
  cancelOrder() {
    this.$dialog
      .confirm({
        title: '是否取消订单',
        showCancelButton: true,
        overlay: false
      })
      .then(() => {
        // on confirm
        cancelStoreOrder(this.params).then((res) => {
          let msg = ''
          if (res.code === '000000') {
            msg = '取消订单成功'
          } else if (res.code === '000002') {
            msg = '订货单状态已变更，不可取消订单'
          }
          this.$dialog
            .alert({
              message: msg
            })
            .then(() => {
              this.getInfo()
            })
        })
      })
      .catch(() => {
        // on cancel
      })
  }

  handleBack() {
    if (this.fromPage === '1') {
      backToBefore()
    } else {
      if ( this.$route.query.form === 'detail') {
        this.$router.push({
          path:'/orderMall',
          query:{
            form:'detail'
          }
        })
      } else {
        this.$router.back()
      }
    }
  }

  /**
   * @description: 监听复制
   * @param {*} e 复制内容
   * @return {*}
   */
  copyCode(key) {
    let clipboard = new Clipboard('.copy', {
      text: (trigger) => key
    })
    clipboard.on('success', (e) => {
      this.$toast('复制成功')
    })
    clipboard.on('error', (e) => {
      this.$toast('该浏览器不支持复制')
      e.clearSelection()
    })
  }

  toLog() {
    (this.$refs.orderLog as any).showPopup(this.orderInfo, '0')
    // this.$router.push({
    //   path: '/mallLog',
    //   query: {
    //     storeId: this.orderInfo.storeId,
    //     orderId: this.orderInfo.orderId,
    //     isReturn: '0'
    //   }
    // })
  }

  // 调用原生enterSelectAddress方法去选择收获地址
  toSelectAddress() {
    if (this.orderInfo.orderStatus === 1 && this.isEditOrder) {
      const data = {
        // customerId: this.orderInfo.customerId,
        isShowTemporary: false, // 是否展示临时地址信息 传false就是不展示，true就是展示
        title: '选择收货地址'
      }
      this.$bridge.callHandler('enterSelectAddress', { data }, (res) => {
        const data = !res ? {} : JSON.parse(res)
        this.orderInfo.receiveMan = data.receiveMan
        this.orderInfo.receiveMobile = data.receiveMobile
        this.orderInfo.receiveAddress = data.addressId
        // this.orderInfo.receiveAddress = data.addressName
        this.orderInfo.receiveAddressDtl = data.addressDtl
      })
    }
  }

  valetRefund() {
    let query = this.$route.query
    this.$router.push({
      path: '/valetRefund',
      query: {
        orderId: query.orderId, // 订单id（也可以orderInfo拿）
        currRouteId: query.currRouteId // 分区序号
      }
    })
  }

  /**
   * @description: 删除订单
   * @param {*}
   * @return {*}
   */
  deleteOrder() {
    this.showPopover = false
    this.$dialog
      .confirm({
        title: '温馨提示',
        message: '是否确认删除当前订单?'
      })
      .then(() => {
        let query = this.$route.query
        let orderIdList = [
          {
            orderId: query.orderId, // 订单id（也可以orderInfo拿）
            currRouteId: query.currRouteId // 分区序号
          }
        ]
        let params = {
          companyId: this.companyId,
          operateType: 7, // 删除
          orderIdList
        }
        updateOrderStatus(params).then((res) => {
          this.$toast({
            type: 'success',
            message: '删除成功',
            duration: 1000,
            onClose: () => {
              this.$router.back()
              this.$eventBus.$emit('orderDetail')
            }
          })
        })
      })
      .catch(() => {
        console.log('取消')
      })
  }

  /**
   * @description: 获取配送方式
   * @param {*} obj 数据字典数据
   * @return {*}
   */
  getDistributionWay(obj) {
    this.orderInfo.distributionWay = obj.dataId
    // this.orderInfo.distributionWayName = obj.dataName
  }

  /**
   * @description: 修改商品清单
   * @param {*}
   * @return {*}
   */
  updateGoods() {
    let orderDtlSelect = this.orderInfo.del.map((item) => {
      return {
        ...item,
        isChecked: true
      }
    })
    ;(this.$refs.selectGoods as any).show(
      this.orderInfo.del,
      orderDtlSelect,
      '修改订单商品'
    )
  }

  /* 修改商品选择商品清单 */
  chooseGoods() {
    window.sessionStorage.setItem('toPath', this.$route.path)
    this.$router.push({
      path: '/chooseGoods',
      query: {
        // customerId: this.orderInfo.customerId
      }
    })
  }

  /**
   * @description: 获取商品清单
   * @param {*}
   * @return {*}
   */
  getGoods(data) {
    // this.orderInfo.orderDtlList = data
  }

  /*
   * 附件修改
   * */
  modifyOrderAttachFile(count) {
    const params = {
      companyId: this.companyId,
      orderType: '1', // 1:订货单 2:退货单
      orderId: this.orderInfo.orderId,
      // currRouteId: this.orderInfo.currRouteId,
      orderFileUrl: count.filePath,
      orderFileName: count.fileName,
      orderFileSize: count.fileSize
    }
    modifyOrderAttachFile(params).then((res: any) => {
      if (res.code === '000000') {
        console.log('修改成功')
      } else {
        this.$toast(res.msg)
      }
    })
  }

  /**
   * @description: 保存修改订单
   * @param {*}
   * @return {*}
   */
  saveOrder() {
    let params = {
      companyId: this.companyId,
      ...this.orderInfo,
      purchaseOrderDtlList: this.selectGoodsList.map((item) => {
        return {
          versionId: item.versionId,
          goodsId: item.goodsId,
          packageId: item.packageId,
          saleAmount: item.saleAmount
        }
      })
      // purchaseOrderDtlList: this.orderInfo.orderDtlList
    }
    // delete params.orderDtlList
    // delete params.orderRemarkList
    modifyOrder(params).then((res) => {
      this.$toast({
        type: 'success',
        message: '保存成功',
        duration: 1000,
        onClose: () => {
          this.isEditOrder = false
          // 刷新订单信息对象
          this.reloadInfo()
        }
      })
    })
  }

  /**
   * @description: 再来一单事件
   * @param {*}
   * @return {*}
   */
  toPlaceOrder() {
    const obj = {
      companyId: this.companyId,
      orderId: this.params.orderId
      // currRouteId: this.params.currRouteId
    }
    purchaseOrderAgainAppApi(obj).then((res) => {
      if (res.code === '000000') {
        this.$router.push({
          path: '/valetOrder',
          query: {
            orderId: this.params.orderId,
            // currRouteId: this.params.currRouteId,
            placeType: '2' // '2'为再来一单
          }
        })
      }
    })
  }

  /**
   * @description: 操作方法
   * @param {*操作类型：1：订单审核2：出库确认3：发货确认6：作废7：删除8：付款确认 9:退回} operateType
   * @param {*操作对象} obj
   * @return {*}
   */
  handleOperation(operateType) {
    let title
    let message
    let isRequired // 备注是否必填
    let isNumberInput // 确认收付款改为number输入框判断是否显示number输入框
    switch (operateType) {
      case 1:
        title = '订单审核'
        message = '是否确认订单审核通过？'
        isRequired = false
        isNumberInput = false
        break
      case 2:
        title = '出库确认'
        message = '是否确认出库？'
        isRequired = false
        isNumberInput = false
        break
      case 3:
        title = '发货确认'
        message = '是否确认发货？'
        isRequired = false
        isNumberInput = false
        break
      case 6:
        title = '作废确认'
        message = '是否确认作废订单？'
        isRequired = true
        isNumberInput = false
        break
      case 8:
        title = '确认收款'
        message = '是否确认订单收款完成？'
        isRequired = false
        isNumberInput = true
        break
      case 9:
        title = '退回确认'
        message = '是否确认退回订单重新审核？'
        isRequired = true
        isNumberInput = false
        break
    }
    ;(this.$refs.handleFlow as any).show({
      title,
      message,
      operateType,
      isRequired,
      isNumberInput
    })
  }

  /**
   * @description: 修改订货单状态方法
   * @param {*请求参数} params
   * @param {*提示} tips
   * @return {*}
   */
  updateOrderStatus(params, successTips) {
    updateOrderStatus(params).then((res) => {
      this.$toast({
        type: 'success',
        message: `${successTips}`,
        duration: 1000,
        onClose: () => {
          // 刷新订单信息对象
          this.reloadInfo()
        }
      })
    })
  }

  /**
   * @description: 修改订货单付款状态方法
   * @param {*请求参数} params
   * @param {*提示} tips
   * @return {*}
   */
  updateOrderPayStatus(params, successTips) {
    updateOrderPayStatus(params).then((res) => {
      this.$toast({
        type: 'success',
        message: `${successTips}`,
        duration: 1000,
        onClose: () => {
          // 刷新订单信息对象
          this.reloadInfo()
        }
      })
    })
  }

  handleFlowConfirm({ remark, operateType }) {
    // 成功提示
    let successTips
    switch (operateType) {
      case 1:
        successTips = '订单审核通过'
        break
      case 2:
        successTips = '订单出库成功'
        break
      case 3:
        successTips = '订单发货成功'
        break
      case 6:
        successTips = '订单作废成功'
        break
      case 8:
        successTips = '确认付款完成'
        break
      case 9:
        successTips = '退回成功'
        break
    }
    // 处理获取请求参数
    let query = this.$route.query
    if (operateType === 9) {
      // 退回
      let params = {
        companyId: this.companyId,
        orderId: query.orderId,
        currRouteId: query.currRouteId,
        Remark: remark
      }
      backOrder(params).then((res) => {
        this.$toast({
          type: 'success',
          message: `${successTips}`,
          duration: 1000,
          onClose: () => {
            // 刷新订单信息对象shouhuo
            this.reloadInfo()
          }
        })
      })
    } else if (operateType === 8) {
      let params = {
        companyId: this.companyId,
        currRouteId: query.currRouteId,
        orderId: query.orderId,
        orderType: 1,
        money: toNumber(remark)
      }
      this.updateOrderPayStatus(params, successTips)
    } else {
      let orderIdList = [
        {
          currRouteId: query.currRouteId,
          orderId: query.orderId
        }
      ]
      let params = {
        companyId: this.companyId,
        operateType,
        orderIdList,
        orderRemark: remark
      }
      this.updateOrderStatus(params, successTips)
    }
    this.reloadInfo()
  }

  /**
   * @description: 获取进度条数据
   * @param {*}
   * @return {*}
   */
  getStepList() {
    let params = {
      orderId: this.orderInfo.orderId,
      // currRouteId: this.orderInfo.currRouteId
      // currRouteId: '1'
      // 订货传：storeOrderNode 退货传：storeReturnOrderNode
      type: 'storeOrderNode'
    }
    // getOrderOrReturnNodeList(params).then((res) => {
    getStoreOrderNodeList(params).then((res) => {
      const list = res.data || []
      this.stepList = list.map((item: any) => {
        return {
          key: Number(item.nodeId),
          title: item.nodeName.replace('【客户】', '') // 将'【客户】'去掉，避免title过长
          // isValid: item.isValid
        }
      })
    })
  }

  /**
   * @description: 获取订单详情信息
   * @param {*}
   * @return {*}
   */
  getInfo() {
    this.isInit = false
    this.isUpdateOrderInfo = false
    // 采购单
    // getOrderInfo(this.params).then((res) => {
    getStoreOrderDtl(this.params).then((res) => {
      // this.orderInfo = res.data
      // this.params.orderId = this.orderInfo.orderId
      // this.params.customerId = this.companyId
      // this.params.companyId = this.companyId
      // this.params.shopId = res.data.shopCompanyId
      // this.params.currRouteId = res.data.currRouteId
      // console.log(123, this.params)
      // this.selectGoodsList = res.data.orderDtlList.map((item) => {
      //   return {
      //     goodsId: item.goodsId,
      //     goodsName: item.goodsName,
      //     imageNameUrl: item.packageMainImage,
      //     versionId: item.versionId,
      //     saleAmount: item.saleAmount,
      //     orderPrice: item.salePrice,
      //     packageId: item.setmealId,
      //     maximum: item.maximum,
      //     minimum: item.minimum,
      //     // packageName: item.packageName,
      //     packageNameDesc: item.packageNameDesc
      //   }
      // })
      // this.setSelectList(this.selectGoodsList)
      // // 获取进度条数据

      this.$nextTick(() => {
        this.isInit = true
      })
      console.log('res', res)
      this.orderInfo = res.data[0]
      if (this.orderInfo.distributionWay === 2 && this.orderInfo.pickupId) this.handlePickupInfo()
      this.selectGoodsList = res.data[0].del
      this.getStepList()
    })
  }

  // 获取站点自提信息
  handlePickupInfo () {
    const days = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    const netDate = (this.orderInfo.deliveryDate as string).substring(0, 10)
    const today = dayjs().format('YYYY-MM-DD')
    const tomorrow = dayjs().add(1, 'day').format('YYYY-MM-DD')
    this.pickUpInfo.sendDay = netDate
    if (netDate === today) {
      this.pickUpInfo.sendDay = '今天'
    } else if (netDate === tomorrow) {
      this.pickUpInfo.sendDay = '明天'
    }
    this.pickUpInfo.weekNum = days[dayjs(netDate).get('day')]
    this.getLocationInfo()
    getPickupConfig({ storeId: this.orderInfo.storeId, pickupId: this.orderInfo.pickupId }).then(res => {
      if (res.data.pickupList && res.data.pickupList.length) {
        this.pickUpInfo = { ...this.pickUpInfo, ...res.data.pickupList[0] }
      }
    })
  }

  // 刷新订单信息对象
  reloadInfo() {
    window.sessionStorage.setItem('isRefresh', '1')
    this.getInfo()
  }

  /**
   *  需求2.0 取消采购单详情的分享功能
   *  以下函数暂时无效
   */
  shareOrder() {
    const data = {
      title: '订单详情',
      content: '分享的内容'
      // url: `http://172.16.101.69:8086/orderDetail?orderId=${this.params.orderId}&currRouteId=${this.params.currRouteId}`
    }
    this.showPopover = false
    // 定时器是为了去掉动画关闭的时间
    setTimeout(() => {
      this.$bridge.callHandler('screenshot', { data }, (res) => {
        console.log('分享成功')
      })
    }, 300)
  }

  /**
   * 格式化金额 仅可录入数字，最少为0.00，最大为99999999.99
   * @param value
   */
  formatterMoney(value) {
    if (value) {
      value = Number(value) > 99999999.99 ? '99999999.99' : value
    } else {
      value = '0'
    }
    return value
      .replace(/0*(\d+)/, '$1')
      .replace(/[^0-9.]/g, '')
      .replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
  }

  editAmount() {
    this.isEdit = true
    this.$nextTick(() => {
      ;(this.$refs.payFreight as any).focus()
    })
  }

  cancelSave() {
    this.$confirmDialog.show({
      okText: '确认',
      cancelText: '取消',
      tips: '取消后修改的内容不会保存，是否确认取消修改？',
      onOk: () => {
        this.isEditOrder = false
        this.setSelectList([])
        return this.$router.back()
      }
    })
  }

  /* 申请退货 */
  applyReturnGoods() {
    console.log('this.orderINfo', this.orderInfo)
    // this.$router.push({
    //   path:'/mallChoosePackage',
    //   query: {
    //     orderId:this.orderId
    //   }
    // })
    // const arr = []
    // this.orderInfo.orderDtlList.forEach((item) => {
    // this.orderInfo.del.forEach((item) => {
    //   if (item.saleAmount) {
    //     arr.push({
    //       // orderDtlId: item.orderDtlId,
    //       returnAmount: item.saleAmount
    //     })
    //   }
    // })
    // if (arr && arr.length > 0) {
    const obj = {
      orderId: this.orderId,
      storeId: this.orderInfo.storeId
    }
    //   // verifyReturnOrderDtl(obj)
    getStoreOrderCanReturn(obj)
      .then((res) => {
        if (res.code === '000000') {
          const data = res.data
          if (data && data.isCanReturn) {
            // 去除中间页
            this.$router.push({
              path: '/mallChoosePackage',
              query: {
                orderId: this.orderId,
                storeId: this.orderInfo.storeId,
                buyCompanyId: this.orderInfo.buyCompanyId,
                form: 'detail'
              }
            })
          } else {
            this.$toast.fail({
              message: '该订货单不可退货，请重新选择',
              duration: 1500,
              onClose: () => {
                this.getInfo()
              }
            })
          }
        }
      })
      .catch(() => {})
    // } else {
    //   this.$toast('此订单没有可退的商品')
    // }
  }
  showGoodsList () {
    (this.$refs.goodsList as any).showPop(this.orderInfo)
  }

  makePhoneCall (phoneNumber: string) {
    callPhone({ tel: phoneNumber })
  }

  // 导航到自提点
  toNavigation (storeInfo: any) {
    const params = {
      longitude: storeInfo.pickupLongitude,  // 经度，浮点型
      latitude: storeInfo.pickupLatitude, // 纬度，浮点型
      name: storeInfo.pickupName
    }
    goToNavigation(params)
  }
}
